import gql from 'graphql-tag';

export const REMOVE_FROM_FAILED_LIST = gql`
    mutation (
        $input: MarketingCampaignParticipantListInput!
        $marketingCampaignId: String!
    ) {
        removeFromFailedList (
            input: $input
            marketingCampaignId: $marketingCampaignId
        )
    }
`;